var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.25V17.75C15.75 16.9544 15.4339 16.1913 14.8713 15.6287C14.3087 15.0661 13.5456 14.75 12.75 14.75H6.75C5.95435 14.75 5.19129 15.0661 4.62868 15.6287C4.06607 16.1913 3.75 16.9544 3.75 17.75V19.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.75C11.4069 11.75 12.75 10.4069 12.75 8.75C12.75 7.09315 11.4069 5.75 9.75 5.75C8.09315 5.75 6.75 7.09315 6.75 8.75C6.75 10.4069 8.09315 11.75 9.75 11.75Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 19.2502V17.7502C20.2495 17.0855 20.0283 16.4397 19.621 15.9144C19.2138 15.389 18.6436 15.0138 18 14.8477",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.84766C15.6453 6.01288 16.2173 6.38818 16.6257 6.91439C17.0342 7.4406 17.2559 8.08778 17.2559 8.75391C17.2559 9.42003 17.0342 10.0672 16.6257 10.5934C16.2173 11.1196 15.6453 11.4949 15 11.6602",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.395d110f688a87179379ba68e4d851ad.svg";
export { ForwardRef as ReactComponent };